import {useCallback} from "react";
import toast from "react-hot-toast";
import Notification from "../components/Notifications/Notification";


export interface NotificationHandler {
    (title: string, message: string | string[]): void
}

export const useNotification = () => {

    const showError: NotificationHandler = useCallback((title, message) => {
        toast.custom((instance) => (
            <Notification instance={instance} title={title} text={message}/>
        ));
    }, []);

    const showWarning: NotificationHandler = useCallback((title, message) => {
        toast.custom((instance) => (
            <Notification instance={instance} title={title} text={message}/>
        ));
    }, []);

    const showSuccess: NotificationHandler = useCallback((title, message) => {
        toast.custom((instance) => (
            <Notification instance={instance} title={title} text={message}/>
        ));
    }, []);

    return {
        showError,
        showWarning,
        showSuccess,
    }
}
